import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/vercel/path0/middleware/redirect.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}